(function () {
  'use strict';

  // Extracts a comparable size key: "US womens 7-7.5 (37)" → "7-7.5"
  function sizeKey(s) {
    var n = String(s).toLowerCase().replace(/['.]/g,'').replace(/\bsize\b/g,'').replace(/\s+/g,' ').trim();
    var m = n.match(/\d+[-]\d+(?:\.\d+)?/);
    if (m) return m[0];
    return n.split(/\s+/)[0] || n;
  }

  // ─── Product page ─────────────────────────────────────────────────────────
  function hideOOSProductOptions() {
    var jsonEl = document.querySelector('product-selector script[type="application/json"]');
    if (!jsonEl) return false;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return false; }
    if (!variants || !variants.length) return false;

    var optionNames = [];
    document.querySelectorAll('.product-selector__buttons legend.product-selector__label').forEach(function (leg) {
      optionNames.push(leg.textContent.trim().toLowerCase());
    });
    if (!optionNames.length) {
      var seen = {};
      document.querySelectorAll('input[type="radio"][name^="options["]').forEach(function (r) {
        var m = r.name.match(/^options\[(.+)\]$/i);
        if (m && !seen[m[1]]) { seen[m[1]] = true; optionNames.push(m[1].toLowerCase()); }
      });
    }

    var oosMap = {};
    optionNames.forEach(function (name) { oosMap[name] = {}; });
    variants.forEach(function (v) {
      optionNames.forEach(function (name, idx) {
        var val = v['option' + (idx + 1)];
        if (val == null) return;
        if (oosMap[name][val] === undefined) oosMap[name][val] = false;
        if (v.available) oosMap[name][val] = true;
      });
    });

    document.querySelectorAll('input[type="radio"][name^="options["]').forEach(function (radio) {
      var m = radio.name.match(/^options\[(.+)\]$/i);
      if (!m) return;
      var optName = m[1].toLowerCase();
      var val = radio.value;
      if (oosMap[optName] && oosMap[optName][val] === false) {
        var li = radio.closest('li');
        if (li) li.style.display = 'none';
      }
    });
    return true;
  }

  // ─── Collection page ──────────────────────────────────────────────────────
  var _availableValues = null;

  function getLabelText(cb) {
    var labelEl = cb.closest('label');
    if (labelEl) return labelEl.textContent.trim();
    if (cb.id) {
      var sibling = document.querySelector('label[for="' + cb.id + '"]');
      if (sibling) return sibling.textContent.trim();
    }
    return cb.value;
  }

  function applyFilterHiding() {
    if (!_availableValues) return;
    document.querySelectorAll('input[name^="filter.v.option"]').forEach(function (cb) {
      var m = cb.name.match(/^filter\.v\.option\.(.+)$/i);
      if (!m) return;
      var optKey = m[1].toLowerCase().replace(/_/g, ' ');
      var set = _availableValues[optKey];
      if (!set) return; // unknown option — don't touch it

      var cbKey = sizeKey(getLabelText(cb));
      var hasMatch = false;
      set.forEach(function (availVal) {
        if (sizeKey(availVal) === cbKey) hasMatch = true;
      });

      if (!hasMatch) {
        var container = cb.closest('li') || cb.closest('label') || cb.parentElement;
        if (container) container.style.display = 'none';
      }
    });
  }

  function fetchAllProducts(handle, cb) {
    var page = 1, all = [];
    function next() {
      fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var prods = data.products || [];
          all = all.concat(prods);
          if (prods.length === 250) { page++; next(); } else { cb(all); }
        })
        .catch(function (e) { console.error('[OOS] fetch error', e); });
    }
    next();
  }

  function hideOOSCollectionFilters() {
    var pathParts = window.location.pathname.split('/');
    var collIdx = pathParts.indexOf('collections');
    if (collIdx === -1 || !pathParts[collIdx + 1]) return;
    var handle = pathParts[collIdx + 1];

    fetchAllProducts(handle, function (allProducts) {
      var availableValues = {};
      allProducts.forEach(function (product) {
        if (!product.variants) return;
        product.variants.forEach(function (variant) {
          if (!variant.available) return;
          product.options.forEach(function (opt, idx) {
            var key = opt.name.toLowerCase();
            if (!availableValues[key]) availableValues[key] = new Set();
            var val = variant['option' + (idx + 1)];
            if (val) availableValues[key].add(val);
          });
        });
      });
      _availableValues = availableValues;
      applyFilterHiding();
    });
  }

  // ─── Bootstrap ────────────────────────────────────────────────────────────
  var isProduct    = document.body.className.includes('template--product');
  var isCollection = document.body.className.includes('template--collection');

  if (isProduct) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hideOOSProductOptions);
    } else {
      hideOOSProductOptions();
    }
  }

  if (isCollection) {
    function init() {
      hideOOSCollectionFilters();
      var observer = new MutationObserver(function () { applyFilterHiding(); });
      observer.observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
})();